export const SIDEBAR_WIDTH = 300;
export const SIDEBAR_WIDTH_PX = '300px';
export const SIDEBAR_WIDTH_COLLAPSED = 60;
export const SIDEBAR_WIDTH_COLLAPSED_PX = '60px';
